import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Button } from '../../../components/Buttons';
import { Left, Right } from '../../../components/Icon';
import { Loader } from '../../../components/Loader';
import { LegacyTransfer } from './LegacyTransfer';

const Container = styled.div``;
const STATE = {
  selected: null,
  legacyTransfer: false,
};
/* eslint-disable react/prefer-stateless-function */
class ORBOverviewComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  render() {
    if (this.props.work) return <Loader small />;
    return (
      <Container>
        <Button small onClick={this.tofn(`/ORB/incoming`)}>
          <Left /> {this.lbl(`vehicle.orb.incoming`)}
        </Button>
        <Button small onClick={this.tofn(`/ORB/stock`)}>
        {this.lbl(`vehicle.orb.stock`)}<Right />
        </Button>
        <br />
        <Button onClick={this.setStateFn({ legacyTransfer: true })} small>
        {this.lbl(`vehicle.orb.release`)}
        </Button>
        {this.state.legacyTransfer ? <LegacyTransfer onClose={this.setStateFn({ legacyTransfer: false })} /> : null}
      </Container>
    );
  }
}

ORBOverviewComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => createStructuredSelector({});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const ORBOverview = compose(
  withConnect,
  withRouter,
)(ORBOverviewComp);
